/* eslint-disable jsx-a11y/media-has-caption */
import React, { useEffect, useState } from "react";
import client, { makePatch } from "@culturehq/client";
import { useHistory } from "react-router-dom";
import { classnames, Form, Loader, ModalDialog, PlainButton, SelectField, SubmitButton } from "@culturehq/components";

import { useDoor, useFetch, useTryCatch } from "app/hooks";
import { Trans } from "app/utils";

import ErrorMessage from "components/common/ErrorMessage";
import PromptIcon from "components/stories/PromptIcon";
import ChqModalDialog from "components/common/ChqModalDialog";

const NestStoryQuestionModal = ({
  children, storyQuestion, onUpdate, onDelete
}) => {
  const history = useHistory();
  const { open, onOpen, onClose } = useDoor(false);
  const [error, setError] = useState();
  const [storyQuestionOptions, setStoryQuestionOptions] = useState([]);
  const [selectedTrend, setSelectedTrend] = useState();

  const { fetching, json: { storyQuestions } } = useFetch(
    () => (
      open
        ? client.getStoryQuestions({ storyTrends: 1 })
        : Promise.resolve({ storyQuestions: [] })),
    [open]
  );

  useEffect(
    () => {
      if (!open || !storyQuestions.length) return;

      setStoryQuestionOptions(storyQuestions.map(({ id, question }) => (
        { label: question, value: id }
      )));
    }, [open, storyQuestions]
  );

  const [{ error: tryCatchError }, onSubmit] = useTryCatch(
    async ({ question }) => {
      const response = await makePatch(`/story_questions/${storyQuestion.id}`, {
        parentStoryQuestion: question
      });
      if (response.storyQuestion) {
        if (onDelete) {
          onDelete(storyQuestion);
        }
        if (onUpdate) {
          onUpdate(response.storyQuestion);
        }
      }

      setError(undefined);
      onClose();
      history.push(`/stories/trend/${response.storyQuestion.id}`);
    },
    [storyQuestion, onClose, history]
  );

  const handleOnSelectQuestion = selected => {
    setSelectedTrend(storyQuestions.find(trend => trend.id === selected));
  };

  if (tryCatchError && tryCatchError.status !== 422) {
    setError(tryCatchError);
    throw tryCatchError;
  }

  return (
    <>
      {children(onOpen)}
      {open && (
        <ChqModalDialog onClose={onClose} className="story-question-modal nest-story-question-modal">
          <ModalDialog.Heading onClose={onClose}>
            <Trans>Nest Prompt in Story Trend</Trans>
          </ModalDialog.Heading>
          <ModalDialog.Body>
            {fetching && <Loader loading />}
            {error && <ErrorMessage error={error} />}
            <p>
              <Trans>
                Select a trend below to nest this prompt. This action cannot be undone.
              </Trans>
            </p>
            <Form onSubmit={onSubmit} initialValues={{ typesAllowed: "all", points: 50 }}>
              <SelectField
                autoFocus
                name="question"
                onChange={handleOnSelectQuestion}
                options={storyQuestionOptions}
                placeholder="Select the trend..."
                required
                allWordsMatch
              />
              <p><Trans>Remember: The prompt will inherit the visibility from the trend</Trans></p>
              {selectedTrend && (
                <div className="ChildPrompts">
                  <h3 className="ChildPrompts-Title"><Trans>PROMPTS</Trans></h3>
                  {selectedTrend.childStoryQuestions.map((childStoryQuestion, index) => (
                    <div key={childStoryQuestion.id} className={classnames("ChildPrompts__Wrapper", `${childStoryQuestion.allowedTypes}`)}>
                      <PlainButton className={classnames("ChildPrompts__Container", `${childStoryQuestion.allowedTypes}`)}>
                        <div className="ChildPrompts__Container-Left">
                          <div className="ChildPrompts__Container-Icon">
                            <PromptIcon allowedTypes={childStoryQuestion.allowedTypes} />
                          </div>
                          <p className="ChildPrompts__Container-Title">{childStoryQuestion.question}</p>
                        </div>
                      </PlainButton>
                    </div>
                  ))}
                </div>
              )}
              <SubmitButton primary>
                {submitting => (
                  submitting ? <Trans>Submitting...</Trans> : <Trans>Nest Prompt</Trans>
                )}
              </SubmitButton>
            </Form>
          </ModalDialog.Body>
        </ChqModalDialog>
      )}
    </>
  );
};

export default NestStoryQuestionModal;
